<template>
    <div class="layout-menu-container">
        <AppSubmenu :items="model" :binFields="binFields" class="layout-menu" :root="true" @menuitem-click="onMenuItemClick" />
        <ul class="layout-menu p-mt-auto">
            <li>
                <a href="#" @click.prevent="linkMicrosoft">
                    <svg height="100%" viewBox="0 0 20 20" width="25px" fit="" preserveAspectRatio="xMidYMid meet" focusable="false"><g fill="none"><path d="M0 0h9.504v9.504H0z" fill="#F25022"></path><path d="M10.496 0H20v9.504h-9.504z" fill="#7FBA00"></path><path d="M0 10.496h9.504V20H0z" fill="#00A4EF"></path><path d="M10.496 10.496H20V20h-9.504z" fill="#FFB900"></path></g></svg>
                    <span>Allow login via Microsoft</span>
                </a>
            </li>
            <li>
                <a href="#" @click.prevent="linkGoogle">
                    <svg height="100%" viewBox="0 0 20 20" width="25px" fit="" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z" fill="#4285F4"></path><path d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z" fill="#34A853"></path><path d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z" fill="#FBBC05"></path><path d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z" fill="#EA4335"></path></svg>
                    <span>Allow login via Google</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import AppSubmenu from './AppSubmenu';

import { mapGetters } from "vuex";
import {getAuth, linkWithPopup, OAuthProvider} from "firebase/auth";

export default {
    props: {
        model: Array,
        binFields: Array
    },
    data() {
        return {
            userAvailable: false
        }
    },
    mounted() {
        this.model.forEach(item => {
            if (item.access) {
                item.visible = item.access <= this.user.data.role.permissionLevel;
            }
        });
        this.binFields.forEach(field => {
            // console.log(field.access <= this.user.data.role.permissionLevel)
            if (field.access) {
                field.visible = field.access <= this.user.data.role.permissionLevel;
                // console.log(field.visible)
            }
        })
        const auth = getAuth();
        auth.onAuthStateChanged((user) => {
            this.userAvailable = !!user;
        })
    },
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
        async linkMicrosoft() {
            const provider = new OAuthProvider('microsoft.com');
            const auth = getAuth();
            try {

                const result = await linkWithPopup(auth.currentUser, provider);
                this.requireSSO = false;
            } catch(error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error.message, life: 5000 })
            }

        },
        async linkGoogle() {
            const provider = new OAuthProvider('google.com');
            const auth = getAuth();
            try {
                const result = await linkWithPopup(auth.currentUser, provider);
                this.requireSSO = false;
            } catch(error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error.message, life: 5000 })
            }
        },
    },
    computed: {
        ...mapGetters({
            user: "user"
        })
    },
    components: {
        'AppSubmenu': AppSubmenu
    }
}
</script>

<style scoped lang="scss">
.policy_footer {
    margin-top: 0;
}
</style>